<script setup>
import { computed, inject, onMounted, onUpdated } from 'vue'
import { nanoid } from 'nanoid'

const register = inject('register')
const update = inject('update')

const id  = nanoid(6)
const props = defineProps({
	fill: { type: String, default: 'white' },
	order: { type: Number, default: 0 },
	radius: { type: Number, default: 0 },
	strokeColor: { type: String, default: '#fff' },
	strokeWidth: { type: Number, default: 0 },
	x: { type: Number, default: 0 },
	y: { type: Number, default: 0 }
})

const circle = computed(() => ({
	id,
	type: 'circle',
	order: props.order,
	draw(ctx) {
		const { x,y,radius,fill,strokeWidth, strokeColor } = props
		ctx.beginPath()
		ctx.arc(x, y, radius, 0, 2 * Math.PI, false)
		ctx.fillStyle = fill
		ctx.fill()

		if (strokeWidth > 0) {
			ctx.lineWidth = strokeWidth
			ctx.strokeStyle = strokeColor
			ctx.stroke()
		}
	}
}))

onMounted(() => register(circle.value))
onUpdated(() => update(circle.value))
</script>

<template>
	<div hidden>
		<!-- circle -->
	</div>
</template>
